import { combineReducers } from 'redux';

import alliances from './alliances';
import * as fromAlliances from './alliances/selectors';
import carriers from './carriers';
import * as fromCarriers from './carriers/selectors';
import itineraries from './itineraries';
import * as fromItineraries from './itineraries/selectors';
import legs from './legs';
import * as fromLegs from './legs/selectors';
import segments from './segments';
import * as fromSegments from './segments/selectors';

import type {
  Alliance,
  AllianceState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/alliances';
import type {
  Carrier,
  CarrierMultipleAggregate,
  CarrierState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/carriers';
import type {
  Itinerary,
  ItineraryById,
  ItineraryState,
  FilterStatusMap,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/itineraries';
import type {
  Leg,
  LegState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/legs';
import type {
  Segment,
  SegmentState,
} from '@web-platform/shared-universal-types/src/redux/state/entities/flights/segments';

export type FlightState = {
  legs: LegState;
  segments: SegmentState;
  alliances: AllianceState;
  carriers: CarrierState;
  itineraries: ItineraryState;
};

export default combineReducers({
  legs,
  segments,
  alliances,
  carriers,
  itineraries,
});

export const leg = (state: FlightState, id: string): Leg | undefined =>
  fromLegs.get(state.legs, id);
export const allLegs = (state: FlightState): Record<string, Leg> => fromLegs.all(state.legs);
export const segment = (state: FlightState, id: string): Segment | undefined =>
  fromSegments.get(state.segments, id);
export const allSegments = (state: FlightState): Record<string, Segment> =>
  fromSegments.all(state.segments);
export const alliance = (state: FlightState, id: number): Alliance | undefined =>
  fromAlliances.get(state.alliances, id);
export const allAlliances = (state: FlightState): Record<number, Alliance> =>
  fromAlliances.all(state.alliances);
export const carrier = (state: FlightState, id: number): Carrier | undefined =>
  fromCarriers.get(state.carriers, id);
export const allCarriers = (state: FlightState): Record<number, Carrier> =>
  fromCarriers.all(state.carriers);
export const carriersMultiple = (state: FlightState): CarrierMultipleAggregate | null =>
  fromCarriers.getMultiple(state.carriers);
export const carriersCurrentResultIds = (state: FlightState): number[] =>
  fromCarriers.getCurrentResultIds(state.carriers);
export const itinerary = (state: FlightState, id: string): Itinerary =>
  fromItineraries.get(state.itineraries, id);
export const allItineraries = (state: FlightState): ItineraryById =>
  fromItineraries.all(state.itineraries);
export const getItineraryFilterStatusMap = (state: FlightState, id: string): FilterStatusMap[] =>
  fromItineraries.getFilterStatusMap(state.itineraries, id);
